import React, { useState, useRef, useEffect } from 'react';
// import { GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Col, Form, Container, Button, Alert, Tabs, Tab } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { trackPromise } from 'react-promise-tracker';
import ButtonLoader from '../../components/ButtonLoader';
import api from '../../api';
import Recaptcha from 'react-recaptcha';

const ContactUs = () => {
    const [tabKey, setTabKey] = useState('contact-form');
    const [verifyCaptcha, setverifyCaptcha] = useState(false);
    const [alert, setAlert] = useState(false);
    const contactUsRef = useRef()

    const validSchema = Yup.object().shape({
        name: Yup.string().required("Required"),
        email: Yup.string().email().required("Required"),
        mobileNumber: Yup.string().required("Required").max(10, 'Phone must contain 11 numbers').min(10, 'Phone must contain 11 numbers'),
        userType: Yup.string().required("Required"),
        subject: Yup.string().required("Required").max(120),
        messageType: Yup.string().required("Required"),
        message: Yup.string().required("Required"),
        reCaptcha: Yup.string().required("Required"),
    });

    const captchaHandleVerify = (token) => {
        console.log({ token });
    }

    const onSubmit = async (values, { resetForm }) => {

        const result = await api.post('/messages', values);
        resetForm();
        setTabKey('contact-finish');
        // ref.current
        // alertHandler('Message Delivered');
        // contactUsRef.current.scrollTo(0, 0)
    }

    // const alertHandler = (message) => {
    //     setSuccessAlert(message);
    //     setTimeout(() => setSuccessAlert(null), 3000);
    // }
    const verifyLoad = () => {
        setverifyCaptcha(true)
    }

    var verifyCallback = function (token, formik) {
        formik.setFieldValue('reCaptcha', token)
        console.log("recaptcha-token:", token);
    };
    const handleFormikFileChange = (e, formik) => {
        // const file = e.target.files[0];
        formik.handleChange(e);
        // setCvFile(file);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [tabKey])

    return (
        <section className="section-contact-us" ref={contactUsRef}>
            <Container>
                <h1>Contact Us</h1>
                {/* {successAlert && (
                    <Alert variant="success">{successAlert}</Alert>
                )} */}
                <p>We really respect and value your privacy.</p>
                <Tabs
                    defaultActiveKey={tabKey}
                    transition={false}
                    id="noanim-tab-example"
                    className="my-tabs"
                >
                    <Tab eventKey="contact-form" title="" active={tabKey === "contact-form" ? true : false}>
                        <Formik
                            onSubmit={(values, formProps) => trackPromise(onSubmit(values, formProps), 'contact-us')}
                            validationSchema={validSchema}
                            enableReinitialize
                            initialValues={{
                                name: '',
                                email: '',
                                mobileNumber: '',
                                userType: '',
                                subject: '',
                                messageType: '',
                                message: '',
                                reCaptcha: ""
                            }}
                        >
                            {(formik) => (
                                <Form onSubmit={formik.handleSubmit}>
                                    {
                                        alert ?
                                            <Alert variant="danger" className="rounded text-align-center">plz verify are u human being?</Alert>
                                            : ""
                                    }
                                    <Form.Row>
                                        <Form.Group controlId="email" as={Col} hasValidation>
                                            <Form.Label className="form__label">Email</Form.Label>
                                            <Form.Control
                                                className="p-3 rounded-0"
                                                type="text"
                                                name="email"
                                                placeholder="Enter Email"
                                                value={formik.values.email}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isValid={formik.touched.email && !formik.errors.email}
                                                isInvalid={formik.touched.email && formik.errors.email}
                                            />

                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.email}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group controlId="name" as={Col} hasValidation>
                                            <Form.Label className="form__label">Your Name</Form.Label>
                                            <Form.Control
                                                className="p-3 rounded-0"
                                                type="text"
                                                name="name"
                                                placeholder="Enter Your Name"
                                                value={formik.values.name}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isValid={formik.touched.name && !formik.errors.name}
                                                isInvalid={formik.touched.name && formik.errors.name}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.name}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group controlId="mobileNumber" as={Col} hasValidation>
                                            <Form.Label className="form__label">Mobile Number</Form.Label>
                                            <Form.Control
                                                className="p-3 rounded-0"
                                                type="number"
                                                name="mobileNumber"
                                                placeholder="03xxxxxxxxx"
                                                value={formik.values.mobileNumber}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isValid={formik.touched.mobileNumber && !formik.errors.mobileNumber}
                                                isInvalid={formik.touched.mobileNumber && formik.errors.mobileNumber}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.mobileNumber}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group controlId="userType" as={Col} hasValidation>
                                            <Form.Label className="form__label">You are a</Form.Label>
                                            <Form.Control
                                                className="rounded-0"
                                                as="select"
                                                name="userType"
                                                // placeholder="Enter userType"
                                                value={formik.values.userType}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isValid={formik.touched.userType && !formik.errors.userType}
                                                isInvalid={formik.touched.userType && formik.errors.userType}
                                                custom
                                            >
                                                <option value="" disabled>CHOOSE</option>
                                                <option value="seller">Seller</option>
                                                <option value="buyer">Buyer</option>
                                                <option value="affiliate">Affiliate / Influencer</option>
                                                <option value="other">Other</option>
                                            </Form.Control>
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.userType}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group controlId="subject" as={Col} hasValidation>
                                            <Form.Label className="form__label">Subject</Form.Label>
                                            <Form.Control
                                                className="p-3 rounded-0"
                                                type="text"
                                                name="subject"
                                                placeholder="Enter Subject"
                                                value={formik.values.subject}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isValid={formik.touched.subject && !formik.errors.subject}
                                                isInvalid={formik.touched.subject && formik.errors.subject}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.subject}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group controlId="messageType" as={Col} hasValidation>
                                            <Form.Label className="form__label">Message Type</Form.Label>
                                            <Form.Control
                                                className="rounded-0"
                                                as="select"
                                                name="messageType"
                                                value={formik.values.messageType}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isValid={formik.touched.messageType && !formik.errors.messageType}
                                                isInvalid={formik.touched.messageType && formik.errors.messageType}
                                                custom
                                            >
                                                {/* (Business proposal / inquiry / feedback / complaint/ discussion / others) */}
                                                <option value="" disabled>CHOOSE</option>
                                                <option value="seller">Business Proposal</option>
                                                <option value="buyer">Inquiry</option>
                                                <option value="affiliate">Feedback</option>
                                                <option value="affiliate">Complaint</option>
                                                <option value="affiliate">Discussion</option>
                                                <option value="other">Other</option>
                                            </Form.Control>
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.messageType}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group controlId="message" as={Col} hasValidation>
                                            <Form.Label className="form__label">Message</Form.Label>
                                            <Form.Control
                                                className="p-3 rounded-0"
                                                style={{ height: '200px' }}
                                                type="textarea"
                                                as="textarea"
                                                name="message"
                                                placeholder="Enter message"
                                                value={formik.values.message}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isValid={formik.touched.message && !formik.errors.message}
                                                isInvalid={formik.touched.message && formik.errors.message}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>


                                    <Recaptcha
                                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                        render="explicit"
                                        // onloadCallback={() => console.log("clicked")}
                                        verifyCallback={(token) => verifyCallback(token, formik)}
                                        value={formik.values.reCaptcha}
                                        // onChange={e => handleFormikFileChange(e, formik)}
                                        name="reCaptcha"

                                    />
                                    {formik.errors.reCaptcha ?
                                        <span style={{ margintop: "0.25rem", fontSize: "80%", color: "#dc3545" }}>Required</span> : ""} <br />
                                    <Button className="button-ghost mt-4" variant="outline-light" type="submit">
                                        <ButtonLoader trackerArea="contact-us">
                                            Submit
                                        </ButtonLoader>
                                    </Button>
                                </Form>
                            )}
                        </Formik>
                    </Tab>
                    <Tab eventKey="contact-finish" title="" active={tabKey === "contact-finish" ? true : false}>
                        <h5 className="mt-3">Thank you for contacting us.</h5>
                        <span style={{ fontSize: '20px' }}>
                            We have received your message and really appreciate for your time. One of our colleagues will be in contact with you soon! Have a great day!
                        </span>
                    </Tab>
                </Tabs>
                {/* <GoogleReCaptcha onVerify={captchaHandleVerify} /> */}
            </Container>
        </section>
    )
}

export default ContactUs;